import s from '../allservices.jsx'

const getAlertService = (actionCallback,cardDetailsId) => {
    let token = "Token " + localStorage.getItem('token')
    fetch(s.get_alerts + "/" + cardDetailsId , {
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token
        })
    })
        .then(res => {
            if (res.status === 200 || res.status === 201 || res.status === 204 || res.status === 304) {
                res.json().then(json => actionCallback(json, "success"))
            } else {
                // res.json().then(json => actionCallback(json, "error"))
            }
        })
}

export default getAlertService;


// WEBPACK FOOTER //
// ./src/services/components/get_alert.jsx